export default __webpack_public_path__ + "static/media/ddsu5168_4p_wireless_4g.bfc44566.jpg";